import type { onAfterSaveType } from 'app/main/components/hooks/useModel';
import { sendNotification } from 'app/store/notifications/notificationsHubSlice';
import DetailsEventsWrapper from 'app/main/components/page-layouts/details/components/DetailsEventsWrapper';

const sendSaveNotification: onAfterSaveType = ({ dispatch, model, modifiedModel }) =>
	new Promise<void>((resolve, reject) => {
		if (modifiedModel.cntr_user_assigned_uid !== model.cntr_user_modified_uid) {
			dispatch(
				sendNotification({
					message: {
						createdBy: modifiedModel.cntr_user_modified_uid,
						assignedTo: modifiedModel.cntr_user_assigned_uid,
						title: 'Nuovo Contratto assegnato',
						body: `${model.user_modified_title} ti ha assegnato a "${model.cntr_title}".`,
						url: `${window.location.origin}/contracts/details/${model.cntr_uid}`,
						icon: 'handshake',
						variant: 'info'
					}
				})
			);
		}

		resolve();
	});

const onAfterSave: onAfterSaveType = params => DetailsEventsWrapper(params)([sendSaveNotification]);

export default { onAfterSave };
